import { PropType, defineComponent } from 'vue'

import { CsToast, useHeaderStore } from '@sunrise/components'
import { useGlobalStore } from '@sunrise/shared'
import { track } from '@sunrise/tracking'

import { buildTealiumOpenBookmarkListData } from '../../ts/shared/trackingDataBuilder'
import { useBookmarkStore } from '../../ts/store/bookmarkStore/bookmarkStoreModule'
import { BookmarkListBodyType } from '../../ts/utils/trackingUtils.enum'

import { TextContent } from './MsToastManager.enum'
import { Toast } from './MsToastManager.interface'
import { buildTealiumRestoreBookmarkData } from './MsToastManagerTracking'

export default defineComponent({
    name: 'MsToastManager',
    components: {
        CsToast,
    },
    props: {
        toasts: { type: Array as PropType<Toast[]>, default: (): Toast[] => [] },
        isLocalToastManager: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['remove', 'startTimeout', 'stopTimeout'],
    setup(props, { emit }) {
        const headerStore = useHeaderStore()
        const globalStore = useGlobalStore()
        const privacyManagerId = globalStore.privacyManagerId

        function removeId(_id?: number) {
            if (_id === undefined) return

            emit('remove', _id)
        }

        function startTimeout(_id?: number) {
            if (_id === undefined) return

            emit('startTimeout', _id)
        }

        function stopTimeout(_id?: number) {
            if (_id === undefined) return

            emit('stopTimeout', _id)
        }

        function isAdded(toast: Toast): boolean {
            return toast.textContent === TextContent.ADDED
        }

        function isRemoved(toast: Toast): boolean {
            return toast.textContent === TextContent.REMOVED
        }

        function isRemovedCanRevert(toast: Toast): boolean {
            return toast.textContent === TextContent.REMOVED_CAN_REVERT
        }

        function isFull(toast: Toast): boolean {
            return toast.textContent === TextContent.Full
        }

        function isNotAvailable(toast: Toast): boolean {
            return toast.textContent === TextContent.NOT_AVAILABLE
        }

        function restoreBookmark(toast: Toast) {
            if (toast.exposeeId) {
                useBookmarkStore().restoreBookmark(toast.exposeeId)
            }

            if (toast.id !== undefined) {
                removeId(toast.id)
            }
            const tealiumData = buildTealiumRestoreBookmarkData()
            track(tealiumData)
        }

        function openBookmarks(toast: Toast) {
            headerStore.$patch({
                modalOpen: true,
            })

            if (toast.id !== undefined) {
                removeId(toast.id)
            }

            const tealiumData = buildTealiumOpenBookmarkListData(BookmarkListBodyType.TOAST)
            track(tealiumData)
        }

        async function openCookieConsent(toast: Toast) {
            if (window._sp_ && privacyManagerId) {
                window._sp_.loadPrivacyManagerModal(privacyManagerId)
            }

            if (toast.id !== undefined) {
                removeId(toast.id)
            }
        }

        return {
            TextContent,
            removeId,
            startTimeout,
            stopTimeout,
            isAdded,
            isRemoved,
            isRemovedCanRevert,
            isFull,
            isNotAvailable,
            restoreBookmark,
            openBookmarks,
            openCookieConsent,
        }
    },
})
